module.exports = __webpack_public_path__ + "images/369a62a5b0c79a43b3f8cc8960bd1410.svg";